import type { Translations } from '../types';

// Sprint 81 BUG-81-08 §1: unified logo source matches Header.tsx.
const LOGO_SRC = '/assets/QUUL_Logo.png';

interface FooterProps {
  t: Translations;
}

export function Footer({ t }: FooterProps) {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-gray-200 py-8 sm:py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 sm:gap-6">
          {/* Logo & Tagline */}
          <div className="flex flex-col items-center md:items-start gap-1">
            <div className="flex items-center gap-3">
              <img
                src={LOGO_SRC}
                alt="Quul"
                className="w-8 h-8 rounded-lg object-contain"
              />
              <div className="font-semibold text-gray-900">
                &copy; {currentYear} Quul
              </div>
            </div>
            <p className="text-sm text-gray-500 italic">
              Built for communities. By a community.
            </p>
            <p className="text-xs text-gray-500 mt-1">{t.mayilabsLine}</p>
          </div>

          {/* Links */}
          <div className="flex flex-wrap justify-center gap-4 sm:gap-6 text-sm text-gray-600">
            <a
              href="https://quul.app/legal/terms/"
              className="hover:text-vinotinto transition-colors"
            >
              {t.terms}
            </a>
            <a
              href="https://quul.app/legal/privacy/"
              className="hover:text-vinotinto transition-colors"
            >
              {t.privacy}
            </a>
            <a
              href="https://quul.app/legal/child-safety/"
              className="hover:text-vinotinto transition-colors"
            >
              {t.childSafety}
            </a>
            <a
              href="https://quul.app/legal/notice/"
              className="hover:text-vinotinto transition-colors"
            >
              {t.reportNotice}
            </a>
            <a
              href="mailto:hello@quul.app"
              className="hover:text-vinotinto transition-colors"
            >
              {t.contact}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
